import { NavLink, Outlet } from "react-router-dom";
import { FiPlay, FiLink, FiTool, FiZap } from "react-icons/fi";
import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    get_started: "Get started",
    connected_apps: "Connected apps",
    tools: "Tools",
    skills: "Skills",
  },
  fr: {
    get_started: "Démarrer",
    connected_apps: "Applications connectées",
    tools: "Outils",
    skills: "Skills",
  },
};

export default function McpLayout() {
  const { t } = useComponentTranslation(translations);

  const linkClass = ({ isActive }) =>
    `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors -mb-px ${
      isActive
        ? "border-primary text-primary"
        : "border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300"
    }`;

  return (
    <div className="min-h-[calc(100vh-64px)] bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-8">
        <nav className="flex gap-2">
          <NavLink to="/recruiter/mcp/get-started" className={linkClass}>
            <FiPlay className="w-4 h-4" />
            <span>{t("get_started")}</span>
          </NavLink>
          <NavLink to="/recruiter/mcp/connected-apps" className={linkClass}>
            <FiLink className="w-4 h-4" />
            <span>{t("connected_apps")}</span>
          </NavLink>
          <NavLink to="/recruiter/mcp/tools" className={linkClass}>
            <FiTool className="w-4 h-4" />
            <span>{t("tools")}</span>
          </NavLink>
          <NavLink to="/recruiter/mcp/skills" className={linkClass}>
            <FiZap className="w-4 h-4" />
            <span>{t("skills")}</span>
          </NavLink>
        </nav>
      </div>

      <main className="p-8">
        <Outlet />
      </main>
    </div>
  );
}
